module.exports = __webpack_public_path__ + "img/yuanmaiGongZhongHao.e15d4db4.jpg";